module.exports = __webpack_public_path__ + "img/blusao-com-capuz.83f5737b.jpg";